import {useTrackFeature} from '@aboutyou/tracking';
import {Tabs} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {
  DealsTabValue,
  useDealsTabsOpenedState,
} from '../hooks/useDealsTabsOpenedState';

interface Tab {
  label: string;
  value: DealsTabValue;
  count: number | undefined;
  backgroundColor?: string | undefined;
}

type Tabs = Tab[];

interface WishlistDiscountTabsProps {
  tabs: Tabs;
}

export const WishlistDiscountTabs = ({tabs}: WishlistDiscountTabsProps) => {
  const trackFeature = useTrackFeature();
  const {open, parameter} = useDealsTabsOpenedState();

  const onTabClick = (args: string | number) => {
    trackFeature({
      eventType: 'click',
      label: args === DealsTabValue.all ? 'all_items' : 'deal_items',
    });

    open({replaceHistory: true, parameter: args as string});
  };

  return (
    <StyledTabs
      onTabClick={onTabClick}
      dataTestId="DiscountTabs"
      selectedTabValue={parameter}
      tabs={tabs}
      highlightColorOnActive
    />
  );
};

const StyledTabs = styled(Tabs)`
  margin-bottom: -5px;
  padding-inline: 1rem;
`;
